import {
    FINANCEIRO_AGUARDANDO,
    FINANCEIRO_MODO,
    FINANCEIRO_LISTA,
    FINANCEIRO_OPCOES
} from './financeiroActions';

const INITIAL_STATE = {
    aguardando: false,
    pagar: {
        modo: 'lista',
        registro: {},
        lista: [],
        opcoes: {}
    },
    receber: {
        modo: 'lista',
        registro: {},
        lista: [],
        opcoes: {}
    }
};

const chave = tipo => tipo === 'PAGAR' ? 'pagar' : 'receber';

export default (state = INITIAL_STATE, action) => {
    const nome = action.payload && chave(action.payload.tipo);

    switch (action.type) {
        case FINANCEIRO_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case FINANCEIRO_MODO:
            return {
                ...state,
                [nome]: {
                    ...state[nome],
                    modo: action.payload.modo,
                    registro: action.payload.registro || {}
                }
            };

        case FINANCEIRO_LISTA:
            return {
                ...state,
                [nome]: {
                    ...state[nome],
                    lista: action.payload.lista || []
                }
            };

        case FINANCEIRO_OPCOES:
            return {
                ...state,
                [nome]: {
                    ...state[nome],
                    opcoes: action.payload.opcoes || {}
                }
            };

        default:
            return state;
    }
};
